import React, { useState, useEffect } from "react";
import { Box, Skeleton } from "@mui/material";

interface HeroImageProps {
  src: string;
  alt: string;
  onLoad?: () => void;
}

const HeroImage: React.FC<HeroImageProps> = ({ src, alt, onLoad }) => {
  const [loaded, setLoaded] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  // 画像のプリロード
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageLoaded(true);
      setTimeout(() => {
        setLoaded(true);
        onLoad?.();
      }, 100);
    };
    img.onerror = () => {
      // エラー時も表示状態にする
      setImageLoaded(true);
      setLoaded(true);
      onLoad?.();
    };
    // 優先度を高く設定
    img.loading = "eager" as any;
    img.fetchPriority = "high" as any;
    img.src = src;
  }, [src]);

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      {/* スケルトンプレースホルダー */}
      {!loaded && (
        <Skeleton
          variant="rectangular"
          width="100%"
          animation="pulse"
          sx={{
            position: "static",
            height: { xs: 200, sm: 300, md: 400 },
            bgcolor: "rgba(83, 105, 109, 0.1)",
            "&::after": {
              background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
            }
          }}
        />
      )}
      
      {/* 実際の画像 */}
      {imageLoaded && (
        <Box
          component="img"
          src={src}
          alt={alt}
          sx={{
            width: "100%",
            height: "auto",
            display: "block",
            margin: 0,
            padding: 0,
            opacity: loaded ? 1 : 0,
            transition: "opacity 0.6s ease-in-out",
            position: loaded ? "static" : "absolute",
            top: 0,
            left: 0,
            zIndex: loaded ? 1 : 0,
          }}
          {...({ loading: "eager", fetchpriority: "high" } as any)}
        />
      )}
    </Box>
  );
};

export default HeroImage;